import Config from '../Config';
import moment from 'moment';
import {format, format_without_time} from '../Utils';
import { RestService } from './RestService';

export const ReportService = {
    getScheduleReport: async function(date, routeId){
        return RestService.get(`${Config.report_schedule}date=${moment(date).format(format)}&route_id=${routeId}`, {})
        .then(response => response.json());
    },
    getReportMax: async function() {
        return RestService.get(`${Config.report_max}`, {})
        .then(response => response.json());
    },
    getReportSalesStats: async function(startdate, enddate, filter) {
        return RestService.get(`${Config.report_sales_stats}startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&filter=${filter}`, {})
        .then(response => response.json());
    },
    getReportSalesStatsForStore: async function(startdate, enddate, id) {
        return RestService.get(`${Config.report_product_trend_by_user}startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}&filter=${id}`, {})
        .then(response => response.json());
    },
    getReportSalesForStore: async function(startdate, enddate, id) {
        return RestService.get(`${Config.report_store_sales_by_user}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&filter=${id}`, {})
        .then(response => response.json());
    },
    getReportStoresB2W: async function(type, startdate, enddate) {
        return RestService.get(`${Config.report_store_b2w}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&type=${type}`, {})
        .then(response => response.json());
    }, 
    getReportStoresB2WForStore: async function(type, startdate, enddate, id) {
        return RestService.get(`${Config.report_performance_by_user}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&type=${type}&filter=${id}`, {})
        .then(response => response.json());
    }, 
    getReportStoresProductStatsForStore: async function(type, startdate, enddate, timeline, id) {
        return RestService.get(`${Config.report_product_stats_by_user}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&type=${type}&filter=${id}&timeline=${timeline}`, {})
        .then(response => response.json());
    },
    getReportStoresProductSalesStatsForStore: async function(type, startdate, enddate, timeline, id) {
        return RestService.get(`${Config.report_product_sales_stats_by_user}startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}&type=${type}&filter=${id}&timeline=${timeline}`, {})
        .then(response => response.json());
    },
    getReportAgentTotalTransactions: async function(id, startDate, endDate) {
        return RestService.get(`${Config.total_count}data_type=AGENT_TRANSACTIONS&agent_id=${id}&startdate=${moment(startDate).startOf('day').format(format)}&enddate=${moment(endDate).startOf('day').add(1, 'day').format(format)}`, {})
        .then(response => response.json());
    },
    getReportAgentTransactions: async function(id, startDate, endDate, from, offset) {
        return RestService.get(`${Config.get_agent_transactions}agent_id=${id}&startdate=${moment(startDate).startOf('day').format(format)}&enddate=${moment(endDate).startOf('day').add(1, 'day').format(format)}&from=${from}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getReportAgentTransactionsSummary: async function(id, startDate, endDate) {
        return RestService.get(`${Config.get_agent_transactions_summary}agent_id=${id}&startdate=${moment(startDate).startOf('day').format(format)}&enddate=${moment(endDate).startOf('day').add(1, 'day').format(format)}`, {})
        .then(response => response.json());
    },
    getReportCustomerTotalTransactions: async function(id, startDate, endDate){
        return RestService.get(`${Config.total_count}data_type=CUSTOMER_TRANSACTIONS&name=${id}&startdate=${moment(startDate).format(format)}&enddate=${moment(endDate).format(format)}`, {})
        .then(response => response.json());
    },
    getReportCustomerTransactions: async function(id, startDate, endDate, start, numberItems){
        return RestService.get(`${Config.get_customer_transactions}name=${id}&startdate=${moment(startDate).format(format)}&enddate=${moment(endDate).format(format)}&from=${start}&offset=${numberItems}`, {})
        .then(response => response.json())
    },
    getReportPendingBottleDetails: async function(customer_id, product_id){
        return RestService.get(`${Config.report_pending_bottles_detailed}user_id=${customer_id}&product_id=${product_id}`, {})
        .then(response => response.json())
    },
    getReportPendingBottles: async function(){
        return RestService.get(`${Config.report_pending_bottles}`, {})
        .then(response => response.json());
    },
    getReportSalesReport: async function(startDate, endDate){
        return RestService.get(`${Config.report_sales_report}startdate=${moment(startDate).format(format)}&enddate=${moment(endDate).format(format)}`, {})
        .then(response => response.json());
    },
    getReportSummary: async function(date){
        return RestService.get(`${Config.report_summary}date=${moment(date).format(format)}`, {})
        .then(response => response.json());
    },
    getAgentTransactionDetailsMismatch: async function(route_id, agent_id, startDate, endDate, product_id){
        return RestService.get(`${Config.get_agent_transactions_summary_mismatch_txn}${route_id ? '&route_id=' + route_id : ''}${agent_id ? '&agent_id=' + agent_id : ''}&startdate=${moment.utc(startDate).format(format)}&enddate=${moment.utc(endDate).format(format)}&product_id=${product_id}`, {})
        .then(response => response.json());
    },
    exportStoreReport: async function(report_type, startDate, endDate){
        return RestService.get(`${Config.report_store_export}report_type=${report_type}&startdate=${moment(startDate).format(format_without_time)}&enddate=${moment(endDate).format(format_without_time)}`, {});
    },
    routeSummary: async function(date){
        return RestService.get(`${Config.get_route_summary}date=${moment(date).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    routeSummaryExport: async function(date){
        return RestService.get(`${Config.get_route_summary_export}date=${moment(date).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    routeSummaryDetailed: async function(date, route_id){
        return RestService.get(`${Config.get_route_summary_detailed}date=${moment(date).format(format_without_time)}&route_id=${route_id}`, {})
        .then(response => response.json());
    },
    turnoverSummary: async function(days, startdate, enddate){
        return RestService.get(`${Config.get_turnover_summary}days=${days}&startdate=${startdate.format(format_without_time)}&enddate=${enddate.format(format_without_time)}`, {})
        .then(response => response.json());
    },
    turnoverSummaryStateWise: async function(days, startdate, enddate){
        return RestService.get(`${Config.get_turnover_summary}days=${days}&startdate=${startdate.format(format_without_time)}&enddate=${enddate.format(format_without_time)}&statewise=true`, {})
        .then(response => response.json());
    },
    returnsValueSummary: async function(days, startdate, enddate){
        return RestService.get(`${Config.get_returnsvalue_summary}days=${days}&startdate=${startdate.format(format_without_time)}&enddate=${enddate.format(format_without_time)}`, {})
        .then(response => response.json());
    },
    returnsSummary: async function(days ,startdate , enddate){
        return RestService.get(`${Config.get_returns_summary}${ days ? `&days=${days}` : ''}${ startdate ? `&startdate=${startdate.format(format_without_time)}` : ''}${ enddate ? `&enddate=${enddate.format(format_without_time)}` : ''}`, {})
        .then(response => response.json());
    },
    reportReturnsByRoute: async function(startDate, endDate){
        return RestService.get(`${Config.report_returns_by_route}startdate=${moment(startDate).format(format_without_time)}&enddate=${moment(endDate).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    reportReturnsByStore: async function(startDate, endDate){
        return RestService.get(`${Config.report_returns_by_store}startdate=${moment(startDate).format(format_without_time)}&enddate=${moment(endDate).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getTotalActivityCount: async function(startDate, endDate, action, object, filter){
        return RestService.get(`${Config.total_count}data_type=ACTIVITIES&startdate=${startDate.format(format_without_time)}&enddate=${endDate.format(format_without_time)}&action=${action}&object=${object}&filter=${filter}`, {})
        .then(response => response.json());
    },
    getActivities: async function(startDate, endDate, action, object, start, offset, filter, sort, direction){
        return RestService.get(`${Config.get_activities}startdate=${startDate.format(format_without_time)}&enddate=${endDate.format(format_without_time)}&action=${action}&object=${object}&from=${start}&offset=${offset}&filter=${filter}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    getAgentPerformanceGraph: async function(startDate, endDate, agents){
        return RestService.get(`${Config.report_agent_performance_graph}startdate=${startDate.format(format)}&enddate=${endDate.format(format)}&agents=${agents}`, {})
        .then(response => response.json());
    },
    getStoreEarning: async function(startDate, endDate){
        return RestService.get(`${Config.report_store_earnings}startdate=${startDate}&enddate=${endDate}`, {})
        .then(response => response.json());
    },
    saveTemplate: async function(body = {}, headers = {}){
        return RestService.post(`${Config.update_template}`, headers, body)
        .then(response => response.json());
    },

}